import React, { Component, useEffect, useRef, useState } from 'react';
import { HashRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { i18nIntl, shuffleArray, getRoundLabel, scoresToBracket, detectIfBracketHasImages, convertObjectToArray, importCSS, isNotEmpty, getLayout, isColorBright, RGB_2_HEX, throwErrorEvent, getRemotedbUrl } from '../lib/ep.js';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';

import ActionButton, { BackButton, CreateButton, SecondaryButton, SquaredButton } from '../components/builder/ActionButton';
import ActionLink from '../components/builder/ActionLink';
import BuilderCanvas from '../components/builder/BuilderCanvas';
import BuilderSidebar from '../components/builder/BuilderSidebar';
import ButtonCollection from '../components/builder/ButtonCollection.js';
import Checkbox from '../components/builder/Checkbox';
import ColorPicker from '../components/builder/ColorPicker';
import ConfirmButton, { DeleteButton } from '../components/builder/ConfirmButton';
import DateTimePicker from '../components/builder/DateTimePicker';
import DisabledArea from '../components/builder/DisabledArea';
import FloatingLayer from '../components/builder/FloatingLayer';
import ImageUploader, { AutoPostImageUploader } from '../components/builder/ImageUploader';
import Input from '../components/builder/Input';
import Message, { AlertMessage } from '../components/builder/Message';
import Model from '../components/builder/Model';
import NavigationTabs, { NavigationTabsBuilder } from '../components/builder/NavigationTabs';
import SaveButton from '../components/builder/SaveButton';
import SectionTitle from '../components/builder/SectionTitle';
import SectionSubtitle from '../components/builder/SectionSubtitle';
import Select from '../components/builder/Select';
import Spinner from '../components/builder/Spinner';
import TextArea from '../components/builder/TextArea';

import IconedSelectorItems from '../components/wrappers/IconedSelectorItems.js';

import BracketsNotCanvas from '../components/games/BracketsNotCanvas';
import Tooltip from '../components/builder/Tooltip.js';
import BuilderMain from '../components/builder/BuilderMain.js';
import ToggleButton from '../components/builder/ToggleButton.js';
import BuilderSubSectionTitle from '../components/backend/BuilderSubSectionTitle.js';
import TestPromoButton from '../components/backend/elements/TestPromoButton.js';

function getCandidateStatus(candidate_round, current_round, num_rounds) {
	if(current_round == 0) return false;

	let status = (candidate_round < current_round) ? 0 : 1;
	if(candidate_round > num_rounds) status = 2;

	let status_label;
	let status_color;
	let _status = false;
	switch(status) {
		case 0:
			status_label = "Out";
			status_color = 'red';
			_status = '0';
			break;
		case 1:
			status_label = "Active";
			status_color = 'green';
			_status = '1';
			break;
		case 2:
			status_label = "Winner";
			status_color = 'green';
			_status = '2';
			break;
	}

	return { status_label:status_label, status_color:status_color, status:_status };
}

function generateBrackets(items, options) {
	let data = [];

	const pairings_round = options.pairings_round || 1;

	let match = [];
	let round = [];
	let pairings = pairings_round;
	let paired = false;
	for(let i in items) {
		match.push(items[i]);
		if(!paired) {
			paired = true;
			continue;
		}
		round.push(match);
		match = [];
		paired = false;

		if(pairings_round == round.length) {
			data.push(round);
			round = [];
		}
	}

	return data;
}

const ExpiredPromoLayer = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	return (
		<FloatingLayer
			_class={{ size:'small' }}
			enable_close={false}
		>
			<div class="without_actions">
				<SectionTitle
					_class={{
						icon:'knk-settings',
						other:'blackColor',
					}}
				>Promotion expired</SectionTitle>

				<p>{i18n("Timezone")}: <strong>{props.timezone}</strong></p>

				<p>
					<FormattedMessage
						id="Promotion finished on {end_date}"
						values={{
							end_date:<strong>{EPDateFormat(props.end_date, 'LLLL')}</strong>,
						}}
					/>
				</p>

				<Message
					_class={{other:'in_bottom'}}
				>
					<p>{i18n("The end date of the promotion has already pass.")}</p>

					<p>{i18n("Please, go to dates and change it to the future.")}</p>

					<p><ActionLink _href="#dates">Go to edit promotion dates</ActionLink></p>
				</Message>
			</div>
		</FloatingLayer>
	)
};

const DragHandle = SortableHandle(() => <div class="sorter_target" />);

const SortableFields = SortableContainer(({ items, data }) => {
	return (
		<ul class="gui_sortable_list gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap">
			{items.map((candidate, c) => {
				return (
					<SortableItem key={'item-' + c} index={c} candidate={candidate.BracketCandidate} {...data} />
				)
			})}
		</ul>
	);
});

const SortableItem = SortableElement((props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const candidate = props.candidate;

	const enable_changes = (props.enable_changes != undefined) ? props.enable_changes : true;
	const is_sortable = (props.is_sortable != undefined) ? props.is_sortable : false;
	const [is_open, setIsOpen] = useState(false);

	const openCandidate = () => {
		setIsOpen(!is_open);
	};

	const change = (k, v) => {
		props.actions.dispatch({
			type:'CHANGE_CANDIDATE',
			id:candidate.id,
			k,
			v,
		});

		// if(k == 'image' || k == 'background') {
		// 	props.actions.save(()=>{});
		// }
	}

	let status = getCandidateStatus(candidate.round, props.current_round, props.num_rounds);

	return (
		<li class="gui_sortable_list_item gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap gui_flex_align_center">
			<div class={'item_header' + ((is_open) ? ' is_open' : '')}>
				{(is_sortable) && (
					<DragHandle />
				)}

				<div class="item_title_container">
					<ActionLink onClick={() => openCandidate()} icon='knk-football-team-shirt' _class={{ other:'item_title cutTextOnOverflow' }} autotranslate={false}>
						<strong class={(status !== false) ? ('section_status gui_pos_rel ep-circle ' + status.status_color + 'Icon') : null}>
							{(status !== false && status.status === '0') && (
								<span>[{i18n("OUT")}]&nbsp;</span>
							)}
							{candidate.name}
						</strong>
					</ActionLink>
				</div>

				<ButtonCollection>
					{(candidate.status < 2) && (
						<ToggleButton
							onClick={() => openCandidate()}
							active={(is_open) ? true : false}
							icon='knk-hide'
							icon_off='knk-unhide'
						/>
					)}

					{(enable_changes) && (
						<DeleteButton
							squared={true}
							onClick={() => props.actions.delete(candidate.id)}
						/>
					)}
				</ButtonCollection>
			</div>

			{(is_open && candidate.status < 2) && (
				<div class="gui_item_unfoldable_options">
					<div>
						<Model model={candidate} change={change}>
							<Input
								name="name"
								_class={{size:60}}
								max_length={25}
							>***Name</Input>

							<Input
								name="short_name"
								_class={{size:60}}
								max_length={5}
							>Short name</Input>

							<TextArea
								name="description"
								_class={{size:60}}
							>Description</TextArea>

							<AutoPostImageUploader
								auto_url={`/promotions/auto_img/${props.promotion_id}`}
								auto_type="candidate_image"
								image={candidate.full_image}
								name="image"
								_size={{width:400, height:400}}
								small_input={true}
								display_custom_dragging_instructions="Upload file"
							>Image</AutoPostImageUploader>

							<AutoPostImageUploader
								auto_url={`/promotions/auto_img/${props.promotion_id}`}
								auto_type="candidates"
								image={candidate.full_background}
								name="background"
								_size={{width:200, height:100}}
								small_input={true}
								display_custom_dragging_instructions="Upload file"
							>Background image</AutoPostImageUploader>

							<ColorPicker
								name="color"
								_class={{size:60}}
								_hide_code={true}
								color={candidate.color}
							>Background color</ColorPicker>
						</Model>
					</div>
				</div>
			)}
		</li>
	)
});

const BracketsEdit = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props.promotion;

	const [ adding_candidate, setAddingCandidate ] = useState(false);
	const [ bracket_bg_size, setBracketBgSize ] = useState({ width:2000, height:1300 });
	const [ bracket_pairings, setBracketPairings ] = useState([]);
	const [ candidates, setCandidates ] = useState(props?.candidates ?? []);
	const [ display_candidates_as_list, setDisplayCandidatesAsList ] = useState(false);
	const [ display_create_candidates_layer, setDisplayCreateCandidatesLayer ] = useState(false);
	const [ display_next_round_layer, setDisplayNextRoundLayer ] = useState(false);
	const [ display_no_subscription_layer, setDisplayNoSubscriptionLayer ] = useState(false);
	const [ display_stage_close, setDisplayStageClose ] = useState(false);
	const [ display_automatic_options, setDisplayAutomaticOptions ] = useState(false);
	const [ match_to_verify, setMatchToVerify ] = useState(false);
	const [ redirect_to, setRedirectTo ] = useState(false);
	const [ round_dates_editing, setRoundDatesEditing ] = useState(0);
	const [ error_round_dates, setErrorRoundDates ] = useState(false);
	const [ start_round_date, setStartRoundDate ] = useState(null);
	const [ end_round_date, setEndRoundDate ] = useState(null);
	const [ errors, setErrors ] = useState(null);
	const [ reseting_match, setResetingMatch ] = useState(false);
	const [ generating, setGenerating ] = useState(false);
	const [ default_canvas_values, setDefaultCanvasValues ] = useState({});
	
	const bracket = props?.bracket?.Bracket ?? false;
	const max_num_matches_in_round = useRef(candidates.length / Math.pow(2, parseInt(bracket.current_round) + 1));
	const bracket_ref = useRef(null);
	
	const [ temp_options, setTempOptions ] = useState({
		sorting:'0',
		points_per_question:1,
		pairings_round:max_num_matches_in_round.current,
		bracket_candidates:'',
	});

	useEffect(() => {
		importCSS('comp/brackets.css');
		importCSS('comp/agent_cards.css');

		setBracketPairings(generateBrackets(candidates, { pairings_round:temp_options.pairings_round }));
	}, []);

	useEffect(() => {
		setCandidates(props?.candidates ?? []);
	}, [ props.candidates ]);

	if(!bracket) return null;
	const add_candidates_options = [{
		id:'single',
		name:"Add one by one",
		cta_label:"Continue",
	}, {
		id:'bulk',
		name:"Add in bulk by text",
		cta_label:"Continue",
	}, {
		id:'images',
		name:"Add in bulk by image",
		cta_label:"Continue",
	}];

	const add = (cb, passed_candidates) => {
		let type = adding_candidate;
		let c = temp_options.bracket_candidates;
		if(passed_candidates != undefined) {
			c = passed_candidates;
			type = 'bulk';
		}

		const data = {
			type,
		};
		if(type == 'bulk') {
			data.candidates = c.split("\n").map((candidate) => ({
				name:candidate,
				bracket_id:bracket.id,
			}));
		}

		if(type == 'single') {
			data.candidates = [{
				name:c,
				bracket_id:bracket.id,
			}];
		}

		setTempOptions({ bracket_candidates:"" });
		setAddingCandidate(false);

		$.post(getRemotedbUrl(`/stages/add_candidate/${promotion.id}`), data, (res) => {
			if(cb != undefined) cb();
			props.dispatch({ type:'ADD_CANDIDATE', candidates:res });
			setDisplayCreateCandidatesLayer(false);
		}, 'JSON');
	};

	const createByes = (total, cb) => {
		let string_byes = '';
		for(let i = 0; i < total; i++) {
			string_byes += (i > 0) ? "\nbyebyebye" : "byebyebye";
		}

		add(cb, string_byes);
	};

	const modifyBracket = (k, v) => {
		let remove_field_reducer = false;
		if(k.match(/^(start|end)_round_*/)) {
			if(v) {
				v = v.format('YYYY-MM-DD HH:mm:00');
			} else {
				remove_field_reducer = true;
			}
		}

		props.dispatch({
			type:(remove_field_reducer) ? 'DELETE_FIELD_BRACKET' : 'CHANGE_BRACKET',
			k,
			v,
			id:bracket.id,
		});

		setErrors(null);

		//Cases
		if(k == 'type' && v == '0'){
			if(bracket.automatic == '1' || bracket.automatic == true) {
				modifyBracket('automatic', 0);
			}
		}
	};

	const deleteCandidate = (id) => {
		setCandidates(candidates.filter((c) => (c.BracketCandidate.id != id)));
		props.dispatch({ type:'DELETE_CANDIDATE', id });
		$.post(getRemotedbUrl(`/stages/delete_candidate/${promotion.id}`), { id });
	};

	const confirmRandom = () => {
		const winner = (Math.random() > 0.5) ? match_to_verify.candidateA.id : match_to_verify.candidateB.id;
		setMatchToVerify({ ...match_to_verify, winner });

		confirmMatch();	// MARC > FIX THIS TO PASS STATE
	};

	const confirmMatch = () => {
		const data = {
			id:match_to_verify.id,
			candidateA:match_to_verify.candidateA.id,
			candidateB:match_to_verify.candidateB.id,
			winner:match_to_verify.winner,
			scoreA:match_to_verify.scoreA,
			scoreB:match_to_verify.scoreB,
		};

		props.dispatch({
			type:'CHANGE_CANDIDATE',
			k:'round',
			v:parseInt(bracket.current_round) + 1,
			id:match_to_verify.winner,
		});

		$.post(getRemotedbUrl(`/stages/confirm_match/${promotion.id}/${bracket.id}`), data, (res) => {
			props.dispatch({
				type:'REPLACE_MATCH',
				match:res.match,
			})
		}, 'JSON');

		setMatchToVerify(false);
	};

	const resetMatch = (match) => {
		const data = {
			id:match.id,
			candidateA:match.candidateA.id,
			candidateB:match.candidateB.id,
			winner:match.winner,
			reset:true,
		};

		setResetingMatch(match.id);
		
		$.post(getRemotedbUrl(`/stages/reset_match/${promotion.id}/${bracket.id}`), data, (res) => {
			props.dispatch({
				type:'REPLACE_MATCH',
				match:res.match,
			})

			setResetingMatch(false);
		}, 'JSON');

		setMatchToVerify(false);
	};

	const selectWinner = (winner_id) => {
		setMatchToVerify({ ...match_to_verify, winner:winner_id });
	};

	const validateNumCandidates = () => {
		return (props.candidates.length == Math.pow(2, bracket.num_rounds)) ? true : false;
	};

	const resetRound = (e, cb) => {
		const current_round = parseInt(bracket.current_round);

		$.post(getRemotedbUrl(`/stages/reset_phase/${promotion.id}/${bracket.id}`), { phase:(current_round - 1) }, (res) => {
			setRedirectTo(`/${bracket.id}/candidates`);

			props.stageStore.dispatch({ type:'DELETE_STAGES', ids:res });
			props.dispatch({ type:'REMOVE_MATCHES', round:current_round, bracket_id:bracket.id });
			props.dispatch({ type:'CHANGE_BRACKET', k:'current_round', v:current_round - 1, id:bracket.id });
		}, 'JSON');
	};

	const closeStage = (stage_id, cb) => {
		const stages = props?.stages ?? [];
		const stage_to_edit = stages.find((obj) => (obj.Stage.id == stage_id));

		const tz = promotion.timezone;
		const tzcreated = moment.tz(tz).tz('Europe/Madrid').subtract({ minutes:5 });
		const new_end_date = tzcreated.format('YYYY-MM-DD HH:mm:ss')

		stage_to_edit.Stage.end_date = new_end_date;

		$.post(getRemotedbUrl(`/promotions/savestage/${promotion.id}`), stage_to_edit, (res) => {
			const _match_to_verify = { ...display_stage_close };
			const m = (bracket.type == '1') ? {
				..._match_to_verify,
				scoreA:_match_to_verify.votesA,
				scoreB:_match_to_verify.votesB,
			} : _match_to_verify;

			setDisplayStageClose(false);
			setMatchToVerify(m);

			if(cb != undefined) cb();
		}).fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	};

	const nextPhase = () => {
		const current_round = parseInt(bracket.current_round);
		if(current_round == 0 && !validateNumCandidates()) {
			alert("Wrong number of candidates");
			return;
		}

		setGenerating(true);

		$.post(getRemotedbUrl(`/stages/next_phase/${promotion.id}/${bracket.id}`), {
			phase:current_round,
			pairings_round:temp_options.pairings_round,
			points_per_question:temp_options.points_per_question,
		}, (res) => {
			props.stageStore.dispatch({ type:'ADD_STAGES', stages:res.stages });
			props.questionsStore.dispatch({ type:'ADDQUESTION', questions:res.questions });
			props.dispatch({ type:'CHANGE_BRACKET', k:'current_round', v:current_round + 1, id:bracket.id });
			props.dispatch({ type:'ADD_MATCH', match:res.matches});

			setGenerating(false);
			setDisplayNextRoundLayer(false);
			setRedirectTo(`/${bracket.id}/rounds/${current_round + 1}`);
		}, 'JSON');
	};

	const changeConfirmMatch = (k, v) => {
		setMatchToVerify({ ...match_to_verify, [k]:v });
	};

	const changeTempOptions = (k, v) => {
		setTempOptions({ ...temp_options, [k]:v });
	};

	const saveCandidates = (cb) => {
		$.post(getRemotedbUrl(`/stages/save_candidates/${promotion.id}`), {
			candidates:JSON.stringify(props.candidates),
			bracket_id:bracket.id,
		}, (res) => {
			props.dispatch({ type:'SET_CANDIDATES_BRACKET', candidates:res, bracket_id:bracket.id });
			cb();
		}, 'JSON');
	};

	const validate = (res) => {
		if(res.type == undefined) {
			setErrors(null);
			return;
		}

		const message_error = {};
		let msg = "";
		if(res.type == 'automatic') {
			msg = i18n("In order to activate the automatic mode, you must insert the start and end dates for each round. Please, review the schedule of the automatic mode.");
		}
		message_error[res.type] = msg;
		setErrors(message_error);
	};

	const saveBracket = (cb) => {
		const _bracket = { ...bracket };
		delete _bracket.current;

		$.post(getRemotedbUrl(`/stages/save_bracket/${promotion.id}`), {
			bracket:JSON.stringify({Bracket:_bracket}),
		}, (res) => {
			if(!res.status) validate(res);

			setDisplayAutomaticOptions(false);
			setRoundDatesEditing(0);
			if(cb != undefined) cb();
		}, 'JSON');
	};

	const uploadImage = (k, v, name) => {
		const bracket_id = bracket.id;

		if(k == 'images' && v != '') {
			$.post(getRemotedbUrl(`/stages/add_candidate/${promotion.id}`), {
				image:v,
				type:'image',
				name,
				bracket_id,
			}, (res) => {
				props.dispatch({ type:'ADD_CANDIDATE', candidates:res });
				setDisplayCreateCandidatesLayer(false);
			}, 'JSON');
		}
	};

	const adaptCandidatesForBracket = (candidates) => {
		let cands = [];
		candidates.map((ca) => {
			cands.push(ca.BracketCandidate);
		});

		return cands;
	};

	const sortCandidatesByRound = (candidates) => {
		return [ ...candidates ].sort((x, y) => {
			if(x.BracketCandidate.round < y.BracketCandidate.round) return 1;
			if(x.BracketCandidate.round > y.BracketCandidate.round) return -1;
			return 0;
		});
	};

	const sortCandidates = ({ oldIndex, newIndex }) => {
		const candidates = arrayMove(props.candidates, oldIndex, newIndex);

		const data = {};
		for(let i in candidates) {
			data[candidates[i].BracketCandidate.id] = i;
		}

		props.dispatch({ type:'SORT_CANDIDATES', order:data });

		$.post(getRemotedbUrl(`/stages/order_candidates/${promotion.id}/${bracket.id}`), { order:data });
	};

	const randomizeCandidates = () => {
		let counter = 0;
		let candidates = props.candidates.map((c) => ((c.BracketCandidate.pos == null) ? counter++ : c.BracketCandidate.pos));

		let good = false;
		let counter2 = 0;
		while(!good) {
			const shuffled_candidats = shuffleArray(candidates);
			let new_candidates = {};
			shuffled_candidats.map((candidate, index) => {
				new_candidates[candidate] = props.candidates[index];
			});

			new_candidates = convertObjectToArray(new_candidates);

			if(new_candidates.length > 0) {
				good = checkMatchups(new_candidates);
				if(good) {
					props.dispatch({ type:'SHUFFLE_CANDIDATES', order:shuffled_candidats, bracket_id:bracket.id });

					const data = {};
					for(let i in props.candidates) {
						data[props.candidates[i].BracketCandidate.id] = shuffled_candidats[i];
					}

					$.post(getRemotedbUrl(`/stages/order_candidates/${promotion.id}/${bracket.id}`), { order:data });
				}
			}

			if(counter2 > 10) good = true;
			counter2++;
		}
	};

	const formatDateIntervals = (_start_date, _end_date, format = 'L') => {
		const start_date = EPDateFormat(_start_date, format);
		const end_date = EPDateFormat(_end_date, format);

		return (start_date == end_date) ? start_date : `${start_date} - ${end_date}`;
	};

	const openDisplayGenerateLayer = () => {
		let pm = window.pm.attributes;
		let is_test = pm.test != undefined ? pm.test : false;

		if(!window.has_subscription && is_test) {
			setDisplayNoSubscriptionLayer(true);
			return;
		}

		max_num_matches_in_round.current = props.candidates.length / Math.pow(2, parseInt(bracket.current_round) + 1);
		setDisplayNextRoundLayer(true);
		setTempOptions({ ...temp_options, pairings_round:max_num_matches_in_round.current });
	};

	const selectAddingCandidatesOption = (type) => {
		setAddingCandidate(type.id);
	};

	const closeGeneratingRoundLayer = () => {
		if(!generating) setDisplayNextRoundLayer(false);
	};

	const fillDefaultCanvasValues = (k, v) => {
		setDefaultCanvasValues({ ...default_canvas_values, [k]:v });
	};

	const activateTest = () => {
		closeGeneratingRoundLayer();
		//window.handleTestButton.toggleLayerTest();
	};

	const setRoundDates = (index_round) => {
		let pm = window.pm.attributes;

		const roundedDown = Math.floor(EPGetDateMinutes() / 5) * 5;
		const roundedUp = Math.ceil(EPGetDateMinutes() / 5) * 5;

		if(!bracket[`start_round_${index_round}`] || !bracket[`end_round_${index_round}`]) {
			let initial_date = index_round>1 && bracket[`end_round_${index_round - 1}`] ? EPDate(bracket[`end_round_${index_round - 1}`]) : (EPDateBefore(pm.start_date) ? EPDate() : EPDate(pm.start_date));
			let final_date = EPDate(pm.end_date);
			const diff_minutes = EPDateDiff(final_date, initial_date, 'minutes');
			const num_minutes_per_round = Math.floor(diff_minutes / bracket.num_rounds);
			const to_final_date = EPDateFormat(initial_date, 'YYYY-MM-DD HH:mm:00');
			final_date = EPDateAdd(to_final_date, 'minutes', Math.min(4320, num_minutes_per_round));//3 days max;

			modifyBracket(`start_round_${index_round}`, EPGetDateSeconds(EPGetDateMinutes(initial_date, roundedUp), 0));
			modifyBracket(`end_round_${index_round}`, EPGetDateSeconds(EPGetDateMinutes(final_date, roundedDown), 0));
		} else {
			setStartRoundDate(bracket[`start_round_${index_round}`]);
			setEndRoundDate(bracket[`end_round_${index_round}`]);
		}

		setRoundDatesEditing(index_round);
	};

	const validateRoundDates = () => {
		let pm = window.pm.attributes;

		let _error_round_dates = false;

		for(let i = (parseInt(bracket.current_round) + 1); i <= bracket.num_rounds; i++) {
			if(!_error_round_dates) {
				let previous_round_end = (bracket[`end_round_${i - 1}`] != null) ? EPDate(bracket[`end_round_${i - 1}`]) : EPDate(pm.start_date);
				if(EPDateBefore(bracket[`start_round_${i}`], previous_round_end)) _error_round_dates = i;

				let next_round_start = (bracket[`start_round_${i + 1}`] != null) ? EPDate(bracket[`start_round_${i + 1}`]) : EPDate(pm.end_date);
				if(EPDateAfter(bracket[`end_round_${i}`], next_round_start)) _error_round_dates = i;

				if(EPDateAfter(bracket[`start_round_${i}`], bracket[`end_round_${i}`])) _error_round_dates = i;
			}
		}

		setErrorRoundDates(0);
		setRoundDatesEditing(0);
	};

	const closeRoundDates = () => {
		modifyBracket(`start_round_${round_dates_editing}`, (start_round_date) ? EPDate(start_round_date) : null);
		modifyBracket(`end_round_${round_dates_editing}`, (end_round_date) ? EPDate(end_round_date) : null);
		setRoundDatesEditing(0);
	};

	const checkMatchups = (candidates) => {
		let good_matchups = true;
		for (var i = 0; i < candidates.length; i+=2) {
			let candidate_1 = (candidates[i] != undefined) ? candidates[i].BracketCandidate :{};
			let candidate_2 = (candidates[i + 1] != undefined) ? candidates[i + 1].BracketCandidate : {};
			if(candidate_1.status == '2' && candidate_2.status == '2') good_matchups = false; //Status = 2 "BYE"
		}

		return good_matchups;
	};

	const stages = (props.stages != undefined) ? props.stages : [];

	const _basename = props?.basename ?? '';
	const basename = `${_basename}/${bracket.id}`;

	const matches = props.matches;

	let sections = [
		{ label:"Go back", full_link:`#${_basename}`, icon:'knk-go-prev' },
		{ label:i18n("Candidates"), full_link:`/candidates`, icon:'knk-football-team-shirt', router:true },
		{ label:i18n("Settings"), full_link:`/settings`, icon:'knk-settings', router:true },
	];

	if(candidates.length > 0) {
		for(let i = 1; i < Math.min(parseInt(bracket.current_round), parseInt(bracket.num_rounds)) + 1; i++) {
			let _round_label = (bracket[`round_${i}`] != "" && bracket[`round_${i}`]!=null) ? bracket[`round_${i}`] : getRoundLabel(bracket, i, false, props.intl);
			sections.push({ label:_round_label, full_link:`/rounds/${i}`, icon:'knk-brackets', router:true });
		}
	}

	const has_all_candidates = validateNumCandidates();
	const total_candidates_needed = Math.pow(2, bracket.num_rounds);

	let has_bracket_started = true;
	let bracket_status_label;
	let bracket_status_color;
	switch(parseInt(bracket.current_round)) {
		case 0:
			has_bracket_started = false;
			bracket_status_label = i18n("Under construction");
			bracket_status_color = 'orange';
			break;

		case (parseInt(bracket.num_rounds) + 1):
			bracket_status_label = i18n("Finalized");
			bracket_status_color = 'black';
			break;

		default:
			bracket_status_label = `${i18n("Active")} (${getRoundLabel(bracket, bracket.current_round, false, props.intl)})`;
			bracket_status_color = 'green';
			break;
	}

	const asking_groupings = [
		{ k:max_num_matches_in_round.current, v:i18n("Full round") },
		{ k:'1', v:i18n("Per matchup") },
	];

	if(redirect_to != false) {
		const rdr = redirect_to;
		setRedirectTo(false);

		return (
			<Redirect to={rdr} />
		)
	}
	const layout_props = getLayout(promotion);
	const main_color = layout_props.color.main_color;
	const bracket_defaults = {
		bracket,
		main_color,
		main_font:layout_props.text.main_font,
		setDefaultValues:fillDefaultCanvasValues,
		version:'full',
	};

	const will_be_final_round = (parseInt(bracket.num_rounds) == parseInt(bracket.current_round) + 1) ? true : false;
	const is_final_round = (parseInt(bracket.num_rounds) == parseInt(bracket.current_round)) ? true : false;

	let pm = window.pm.attributes;
	let is_test = pm?.test ?? false;
	let is_active = (pm.status == '0') ? false : true;
	let enable_generate_round = (is_test || is_active) ? true : false;

	const matches_results = scoresToBracket(matches, parseInt(bracket.num_rounds), parseInt(bracket.current_round));

	const good_matchups = checkMatchups(candidates);

	const automatic_gen = (bracket.automatic != undefined && bracket.automatic != '0') ? true : false;

	const rounds_in_bracket = [];
	for(let p = bracket.num_rounds; p > 0; p--) {
		rounds_in_bracket.push({
			label:getRoundLabel(bracket, p, true, props.intl),
			description:"",
		});
	}
	rounds_in_bracket.reverse();

	const is_promo_ended = (EPDateBefore(pm.end_date)) ? true : false;

	return (
		<BuilderMain pm={props.promoModel}>
			<Router hashType="noslash" basename={basename}>
				<Switch>
					<Route path={'/settings'} render={(route) => {
						const candidates_for_bracket = adaptCandidatesForBracket(candidates);

						const type_options = [
							{ k:0, v:i18n("By the score of a real matchup") },
							{ k:1, v:i18n("By the users votes") },
						];

						const _has_images = detectIfBracketHasImages(candidates_for_bracket);

						let teams_display_options = [
							{ k:0, v:i18n("Only the name") },
						];
						if(bracket.num_rounds < 4 || true) {
							teams_display_options.push({ k:1, v:i18n("The image and the full name") });
						}
						teams_display_options.push({ k:2, v:i18n("The image and the short name") });
						teams_display_options.push({ k:3, v:i18n("Only the image") });

						const losers_display_options = [
							{ k:'0', v:i18n("None") },
							{ k:'1', v:i18n("Cross") },
							{ k:'2', v:i18n("Blurred") + " (" + i18n("default") + ")" },
							{ k:'3', v:i18n("Cross") + " + " + i18n("Blurred") },
						];

						const bracket_layouts = [
							{ k:'light', v:i18n("Light") },
							{ k:'dark', v:i18n("Dark") },
						];

						return (
							<>
								<BuilderSidebar
									onSave={saveBracket}
									errors={errors}
									custom_button={(!has_bracket_started) ? (
										<DisabledArea disabled={(!has_all_candidates || !good_matchups) ? true : false}>
											<ActionButton
												onClick={() => openDisplayGenerateLayer()}
											>Start competition</ActionButton>
										</DisabledArea>
									) : null}
								>
									<NavigationTabsBuilder active={route.location.pathname} relative_selection={true} sections={sections}>
										<ButtonCollection _class={{other:'gui_flex_end'}}>
											<ActionButton
												color={bracket_status_color}
												_class={{ other:'gui_remove_pointer_events' }}
												autotranslate={false}
											>{bracket_status_label}</ActionButton>
										</ButtonCollection>
									</NavigationTabsBuilder>

									<article>
										<Model model={bracket} change={modifyBracket}>
											<Input
												_class={{size:60, first:true}}
												name="title"
											>***Name</Input>

											<Select
												name="type"
												values={type_options}
											>How will you settle the matchup?</Select>
										</Model>

										<DisabledArea disabled={(bracket.type != undefined && bracket.type == '0') ? true : false} message="The automatic mode is only available if the selection of the winner is by votes, not by a real score." tooltip_position="bottom">
											<Model model={bracket} change={modifyBracket}>
												<Checkbox
													name="automatic"
													label_props={{
														_extra_component:(automatic_gen) ? (<ActionLink onClick={() => setDisplayAutomaticOptions(true)}>Schedule dates</ActionLink>) : null,
														tooltip:<Tooltip>The automatic mode allows you to schedule the opening and closing dates of each round. Candidate progress and the next round of votes are automatically generated based on the most voted candidate from each match at the end of the round.</Tooltip>,
													}}
												>Enable automatic mode</Checkbox>
											</Model>
										</DisabledArea>

										{(bracket.type != undefined && bracket.type == '1' && errors != null && errors.automatic != undefined) && (
											<AlertMessage>
												<p>{errors.automatic}</p>
											</AlertMessage>
										)}
									</article>

									<article class="gui_not_in_top_huge">
										<BuilderSubSectionTitle
											title="Display options"
										/>

										{(_has_images.images == 0 && (bracket.teams_display == 1 || bracket.teams_display == 2)) && (
											<Message
												icon={false}
											>
												<p>{i18n("None of the candidates have an image to display.")}</p>
											</Message>
										)}

										{(_has_images.bg_images == 0 && _has_images.images == 0 && bracket.teams_display == 3) && (
											<Message
												icon={false}
											>
												<p>{i18n("None of the candidates have a background image to display.")}</p>
											</Message>
										)}

										{(_has_images.bg_images == 0 && _has_images.images > 0 && bracket.teams_display == 3) && (
											<Message
												icon={false}
											>
												<p>{i18n("Normal images for the candidates will be displayed instead of background images. Please, upload custom background images for each candidate for optimal display.")}</p>
											</Message>
										)}

										<Model model={bracket} change={modifyBracket}>
											<Select
												_class={{size:60}}
												name="teams_display"
												values={teams_display_options}
											>Candidates view</Select>

											<Select
												name="losers_display"
												values={losers_display_options}
											>How to display eliminated candidates?</Select>

											<Checkbox
												name="display_scores"
											>Show matchup results</Checkbox>

											<Checkbox
												name="autoflip_candidates"
												label_props={{
													tooltip:<Tooltip>This will automatically flip the images of the candidates on the right side horizontally so the candidates face each other on the brackets page</Tooltip>,
												}}
											>Flip images so candidates face each other</Checkbox>

											<AutoPostImageUploader
												auto_url={`/promotions/auto_img/${bracket.promotion_id}`}
												auto_type="brackets"
												image={bracket.full_background_img}
												name="background_img"
												small_input={true}
												_size={bracket_bg_size}
												display_custom_dragging_instructions="Upload file"
											>Background</AutoPostImageUploader>

											<ColorPicker
												name="background_color"
												_class={{size:60}}
												_hide_code={true}
												color={bracket.background_color}
											>Background color</ColorPicker>

											<ColorPicker
												name="header_color"
												_class={{size:60}}
												_hide_code={true}
												color={(bracket.header_color != undefined && bracket.header_color != "") ? bracket.header_color : main_color}
											>Header color</ColorPicker>

											<Select
												_class={{size:60}}
												name="layout"
												values={bracket_layouts}
												value={(bracket.layout != "") ? bracket.layout : (isColorBright(RGB_2_HEX(bracket.background_color)) ? 'light' : 'dark')}
											>Layout</Select>

											{rounds_in_bracket.map((round, r) => {
												return (
													<Input
														key={`round_${r}`}
														_class={{size:60}}
														name={`round_${(r + 1)}`}
														placeholder={round.label}
														autotranslate={false}
													>{i18n("Label for round")} #{(r + 1)}</Input>
												)
											})}
										</Model>
									</article>
								</BuilderSidebar>

								<BuilderCanvas is_adaptable={false} fit_to_window="content" not_awesome={true}>
									{(has_all_candidates) ? (
										<div id="bracket_dom" class="gui_bracket_builder brackets_display bracket_dom">
											<BracketsNotCanvas
												ref={(node) => { bracket_ref.current = node; }}
												matches_results={matches_results}
												is_builder={true}
												current_round={parseInt(bracket.current_round)}
												teams={candidates_for_bracket}
												{...bracket_defaults}
												getBgSize={setBracketBgSize}
												{...default_canvas_values}
											/>
										</div>
									) : (
										<p><FormattedMessage id="To see the bracket, first you need to create the {num_candidates} candidates" values={{num_candidates:total_candidates_needed}} /></p>
									)}
								</BuilderCanvas>
							</>
						)
					}} />

					<Route path={'/candidates'} render={(route) => {
						const candidates_for_bracket = adaptCandidatesForBracket(candidates);

						const sorted_candidates = sortCandidatesByRound(candidates);
						const enable_changes = !has_bracket_started;
						const total_candidates_blank = candidates.filter((obj) => (obj.BracketCandidate.status == '2')).length;

						const blocked_message = "You can't change this option because you already generated the first round.";

						const actions = {
							delete:deleteCandidate,
							dispatch:props.dispatch,
							save:saveCandidates,
						};

						const sorting_options = [
							{ k:'0', v:i18n("Manual") },
							{ k:'1', v:i18n("Random") },
						];

						const candidates_canvas_options = [{
							label:"Candidates view",
							onClick:() => setDisplayCandidatesAsList(true),
							icon:'knk-list-gallery',
							selected:((display_candidates_as_list == true) ? true : false),
						}, {
							label:"Bracket view",
							onClick:() => setDisplayCandidatesAsList(false),
							icon:'knk-brackets',
							selected:((display_candidates_as_list == false) ? true : false),
						}];

						const display_view_tabs = (has_all_candidates && bracket.current_round == 0) ? true : false;

						const max_available_blanks = total_candidates_needed / 2 - 1;
						const available_blanks = Math.min(max_available_blanks, total_candidates_needed - total_candidates_blank - candidates.length);
						const display_byes = (available_blanks > 0) ? true : false;

						return (
							<>
								<BuilderSidebar
									onSave={saveCandidates}
									custom_button={(!has_bracket_started) ? (
										<DisabledArea disabled={(!has_all_candidates || !good_matchups) ? true : false}>
											<ActionButton
												onClick={() => openDisplayGenerateLayer()}
											>Start competition</ActionButton>
										</DisabledArea>)
									: null}
								>
									<NavigationTabsBuilder active={route.location.pathname} relative_selection={true} sections={sections}>
										<ButtonCollection _class={{other:'gui_flex_end'}}>
											<ActionButton
												color={bracket_status_color}
												_class={{ other:'gui_remove_pointer_events' }}
												autotranslate={false}
											>{bracket_status_label}</ActionButton>
										</ButtonCollection>
									</NavigationTabsBuilder>

									{(enable_changes && has_all_candidates) && (
										<article>
											<Model model={temp_options} change={changeTempOptions}>
												<Select
													_class={{ size:50, first:true }}
													name="sorting"
													values={sorting_options}
												>Candidates order</Select>
											</Model>

											{(temp_options.sorting == '1') && (
												<ButtonCollection _class={{ other:'not_in_top' }}>
													<ActionButton
														onClick={randomizeCandidates}
													>Reorder</ActionButton>
												</ButtonCollection>
											)}
										</article>
									)}

									<article class={(enable_changes && has_all_candidates) ? 'gui_not_in_top_huge' : null}>
										{(!has_all_candidates && candidates.length < total_candidates_needed) && (
											<Message
												title={`${i18n("Candidates left")}: ${total_candidates_needed - candidates.length}`}
												autotranslate={false}
												_class={{ other:'in_top' }}
											>
												<p><FormattedMessage id="Once you have created the {num_candidates} candidates, you will generate the first round of votes." values={{num_candidates:total_candidates_needed}} /></p>
											</Message>
										)}

										{(!has_all_candidates && candidates.length > total_candidates_needed) && (
											<Message
												title={`${i18n("Number of candidates exceeded")}: ${candidates.length - total_candidates_needed}`}
												autotranslate={false}
												_class={{ other:'in_top' }}
											>
												<p><FormattedMessage id="Once you have removed {exceeded_candidates} candidate(s), you will generate the first round of votes." values={{exceeded_candidates:(candidates.length > total_candidates_needed)}} /></p>
											</Message>
										)}

										{(!good_matchups) && (
											<AlertMessage
												title="Matchups with errors"
												_class={{ other:'in_top' }}
											>
												<p>{i18n("Matchups with only byes are not allowed. Please reorder candidates.")}</p>
											</AlertMessage>
										)}

										{(sorted_candidates.length > 0) && (
											<div>
												<BuilderSubSectionTitle
													title={`${i18n("Candidates")} [<span class="${(candidates.length != total_candidates_needed) ? 'redColor' : null}">${candidates.length}</span>/${total_candidates_needed}]`}
													title_actions={
														<DisabledArea
															disabled={((candidates.length >= total_candidates_needed) || !enable_changes) ? true : false}
															message={(candidates.length >= total_candidates_needed) ? "You reached the maximum number of candidates" : blocked_message}
															tooltip_position="bottom"
														>
															<CreateButton
																onClick={(enable_changes) ? () => setDisplayCreateCandidatesLayer(true) : null}
															>Add candidates</CreateButton>
														</DisabledArea>
													}
													bordered={(sorted_candidates.length > 0) ? false : null}
												/>

												{(sorted_candidates.length > 0) && (
													<SortableFields
														items={sorted_candidates}
														data={{
															actions:actions,
															is_sortable:(bracket.current_round == 0 && has_all_candidates) ? true : false,
															enable_changes:enable_changes,
															current_round:bracket.current_round,
															num_rounds:bracket.num_rounds,
															promotion_id:bracket.promotion_id,
															intl:props.intl,
														}}
														useDragHandle={true}
														onSortEnd={sortCandidates}
													/>
												)}

												{(display_byes) && (
													<Message
														_class={{ other:'in_bottom' }}
													>
														<p>{i18n("Create byes for the rest of the candidates")}</p>

														<ButtonCollection>
															<SaveButton
																onClick={(e, cb) => createByes(available_blanks, cb)}
																autotranslate={false}
															>{props.intl.formatMessage({ id:"Add {left_candidates} byes" }, { left_candidates:available_blanks })}</SaveButton>
														</ButtonCollection>
													</Message>
												)}
											</div>
										)}
									</article>
								</BuilderSidebar>

								<BuilderCanvas
									is_adaptable={false}
									fit_to_window="content"
									not_awesome={true}
									add_public_css_vars={false}
								>
									{(sorted_candidates.length > 0) ? (
										<div>
											{(display_view_tabs) && (
												<NavigationTabs
													sections={candidates_canvas_options}
													display_type='tab'
													_class={{ other:'not_in_top', background:false }}
												/>
											)}

											<div style={(display_view_tabs) ? {background:'rgba(0, 0, 0, 0.2)', padding:'1em', border:'1px solid', borderTop:'none', maxHeight:'calc(100dvh - 161px)', overflow:'auto'} : null}>
												{(display_candidates_as_list || !display_view_tabs) ? (
													<div class="builder_multilist_preview cards_display">
														<div class="container" style={{ gridTemplateColumns:'repeat(4, 1fr)' }}>
															{sorted_candidates.map((_candidate, c) => {
																const candidate = _candidate.BracketCandidate;
																if(candidate.status > 1) return null;	// byes are not displayed

																let short_name = (candidate.short_name != undefined && candidate.short_name != "") ? candidate.short_name : false;
																let avatar = (candidate.full_image != undefined && candidate.full_image != "") ? candidate.full_image : false;
																let initials = (!avatar) ? ((short_name) ? short_name : (c + 1)) : false;

																let status = getCandidateStatus(candidate.round, bracket.current_round, bracket.num_rounds);
																let extra_classes = ['_card', 'gui_remove_pointer_events'];
																if(status !== false) {
																	switch(status.status) {
																		case '0':
																			extra_classes.push('is_out');
																			break;
																		case '1':
																			extra_classes.push('is_active');
																			break;
																		case '2':
																			extra_classes.push('is_winner');
																			break;
																		default:
																			break;
																	}
																}

																const candidate_round = getRoundLabel(bracket, candidate.round, false, props.intl);

																const candidate_bg_color = (candidate.color != undefined && candidate.color != "") ? true : false;
																let candidate_styles = null;
																if(candidate_bg_color) {
																	let in_color = isColorBright(RGB_2_HEX(candidate.color)) ? 'rgba(0, 0, 0, 0.3)' : 'rgba(255, 255, 255, 0.4)';
																	candidate_styles = { background:candidate.color, color:in_color };
																}

																return (
																	<div key={`candidate_${c}`} class={extra_classes.join(" ")}>
																		<div class="gui_pos_rel avatar_manager">
																			{(initials) && (
																				<span class="account_initials gui_pos_abs" style={candidate_styles}>{initials}</span>
																			)}

																			{(avatar) && (
																				<span style={{backgroundImage:'url(' + avatar + ')'}}><img src={window.cdn_url + 'img/blank_1x1.png'} width="100%" /></span>
																			)}

																			{(status !== false) ? (
																				<p class="role">
																					<span class={`${status.status_color}Bg`}>{i18n(status.status_label)}</span>
																				</p>
																			) : (
																				<p class="role" />
																			)}
																		</div>

																		<div class="_info">
																			<h4 class="title">{candidate.name}</h4>
																			{(candidate.description) && (
																				<div class="long_description" dangerouslySetInnerHTML={{ __html:i18n(candidate.description).replace(/\n/g, '<br />')}} />
																			)}
																			<div class="gui_ribbons gui_overflowed_auto gui_flex_center gui_not_in_top_small gui_flex_col">
																				{(short_name && avatar) && (
																					<span class="ribbon lightgrayBg blackColor">{short_name}</span>
																				)}
																				<span class="ribbon lightgrayBg blackColor">{candidate_round}</span>
																			</div>
																		</div>
																	</div>
																)
															})}
														</div>
													</div>
												) : (
													<div id="bracket_dom" class="gui_bracket_builder brackets_display bracket_dom">
														<BracketsNotCanvas
															matches_results={matches_results}
															is_builder={true}
															current_round={1}
															teams={candidates_for_bracket}
															{...bracket_defaults}
															{...default_canvas_values}
														/>
													</div>
												)}
											</div>
										</div>
									) : (
										<div>
											<p><strong>{i18n("You don't have any candidates in the bracket yet.")}</strong></p>
											<p>{i18n("Begin creating the competition by creating the candidates. You can add them one by one or all at once.")}</p>
											<ButtonCollection _class={{other:'not_in_top'}}>
												<ActionButton
													_class={{other:'addButton'}}
													onClick={(enable_changes) ? () => setDisplayCreateCandidatesLayer(true) : null}
												>Add candidates</ActionButton>
											</ButtonCollection>
										</div>
									)}
								</BuilderCanvas>

								{(display_create_candidates_layer) && (
									<FloatingLayer
										_class={{ size:'small' }}
										backButton={() => setDisplayCreateCandidatesLayer(false)}
									>
										<div>
											<div>
												<SectionTitle>Add candidates</SectionTitle>
							
												<Model model={temp_options} change={changeTempOptions}>
													{(adding_candidate == 'single') && (
														<Input
															_class={{ first:true, size:50 }}
															name="bracket_candidates"
															max_length={25}
														>Candidate name</Input>
													)}
							
													{(adding_candidate == 'bulk') && (
														<TextArea
															_class={{ first:true }}
															name="bracket_candidates"
															after_component={`[${i18n("Add one candidate name per line")}]`}
														>Candidates names</TextArea>
													)}
												</Model>
							
												{(adding_candidate == 'images') && (
													<ImageUploader
														name="images"
														nopreview={true}
														change={uploadImage}
														_class={{ first:true }}
														_size={{width:400, height:400}}
														_thumb_size={{ width:'100%', height:150 }}
														after_component={`[${i18n("The candidates' names will be generated using the filenames of the images.")}]`}
													>Upload the images of the candidates</ImageUploader>
												)}
							
												{(!adding_candidate) && (
													<IconedSelectorItems
														items={add_candidates_options}
														onSelectItem={selectAddingCandidatesOption}
													/>
												)}
											</div>
							
											<ButtonCollection in_floating={true}>
												<SaveButton
													disabled={(!adding_candidate || adding_candidate == 'images' || temp_options.bracket_candidates == "") ? true : false}
													onClick={(e, cb) => add(cb)}
												>Create candidates</SaveButton>
							
												{(adding_candidate !== false) ? (
													<BackButton
														onClick={() => setAddingCandidate(false)}
													/>
												) : (
													<SecondaryButton
														icon='knk-off'
														onClick={() => setDisplayCreateCandidatesLayer(false)}
													>Close</SecondaryButton>
												)}
											</ButtonCollection>
										</div>
									</FloatingLayer>
								)}
							</>
						)
					}} />

					<Route exact={false} path={'/rounds/:id'} render={(route) => {
						if(bracket.current_round == 0) {
							return (
								<Redirect to={`/candidates`} />
							)
						}

						const round_id = parseInt(route.match.params.id);

						if(bracket.current_round < round_id) {
							return (
								<Redirect to={`/rounds/${round_id - 1}`} />
							)
						}

						const candidates_for_bracket = adaptCandidatesForBracket([ ...candidates ]);

						let total_results = 0;
						let matches_in_round = matches.map((m) => {
							let bm = m.BracketMatch;
							if(bm.round == round_id) {
								total_results += parseInt(bm.votesA);
								total_results += parseInt(bm.votesB);
							}

							if(bm.candidateA.id != undefined) return bm;

							bm.candidateA = candidates.find((c) => c.BracketCandidate.id == bm.candidateA).BracketCandidate;
							bm.candidateB = candidates.find((c) => c.BracketCandidate.id == bm.candidateB).BracketCandidate;
							bm.round = Math.min(bm.candidateA.round,bm.candidateB.round);

							return bm;
						}).filter((m) => (m.round == round_id));

						let matches_to_validate = matches_in_round.filter((obj) => { return obj.status == 0 }).length;

						let can_generate_next_round = (matches_in_round.filter((m) => m.status != 1).length > 0) ? false : true;

						let is_old_round = (bracket.current_round > round_id) ? true : false;

						let actual_stage = false;
						let all_in_one_stage = (matches_in_round.length > 1 && matches_in_round[0].stage_id != matches_in_round[1].stage_id) ? false : true;

						let is_stage_closed = false;
						let title_one_stage = false;
						let timezone = promotion.timezone;
						if(all_in_one_stage) {
							if(matches_in_round.length < 1) return null;
							actual_stage = stages.length > 0 ?  stages.find((obj) => (obj.Stage.id == matches_in_round[0].stage_id)).Stage : {};
							is_stage_closed = (moment.tz(actual_stage.end_date,timezone).isBefore()) ? true : false;
							title_one_stage = getRoundLabel(bracket, round_id, false, props.intl);
						}

						const tied_match = (match_to_verify != false && match_to_verify.votesA == match_to_verify.votesB) ? true : false;

						return (
							<>
								<BuilderSidebar
									custom_button={(!is_old_round && !is_final_round && !automatic_gen) ? (
										<DisabledArea disabled={(!can_generate_next_round) ? true : false}>
											<ActionButton
												_position="top"
												onClick={(can_generate_next_round) ? () => openDisplayGenerateLayer() : null}
											>Generate next round</ActionButton>
										</DisabledArea>)
									: null}
								>
									<NavigationTabsBuilder active={route.location.pathname} relative_selection={true} sections={sections}>
										<ButtonCollection _class={{other:'gui_flex_end'}}>
											<ActionButton
												color={bracket_status_color}
												_class={{ other:'gui_remove_pointer_events' }}
												autotranslate={false}
											>{bracket_status_label}</ActionButton>
										</ButtonCollection>
									</NavigationTabsBuilder>

									{(all_in_one_stage) && (
										<article class="single_stage_in_bracket">
											<div >
												<div class="gui_flexbox gui_flex_nowrap gui_flex_align_center">
													<p class="match_title">{i18n("Voting")}</p>
												</div>
												<p class="match_dates">
													{formatDateIntervals(actual_stage.start_date, actual_stage.end_date)}

													{(is_stage_closed) && (
														<strong class="redColor gui_not_in_start_tiny">[{i18n("closed", 'ucfirst')}]</strong>
													)}
												</p>
											</div>

											<ButtonCollection>
												<SquaredButton
													icon='knk-edit'
													_href={`#stages/${actual_stage.id}/options`}
													aria-label="Edit"
												/>
											</ButtonCollection>
										</article>
									)}

									<article class={(all_in_one_stage) ? 'gui_not_in_top_big' : null}>
										{(all_in_one_stage) && (
											<BuilderSubSectionTitle
												title={`${props.intl.formatMessage({ id:"Matchups in {round}" }, { round:`"${title_one_stage}"` })} [${matches_in_round.length}]`}
											/>
										)}

										<ul class="match_info_list">
											{matches_in_round.map((match, m) => {
												let is_verified = (match.status == 1) ? true : false;
												let verification_action = (!is_verified) ? (() => {
													let stage_to_check = {};
													if(all_in_one_stage) {
														stage_to_check = actual_stage;
													} else {
														stage_to_check = stages.find((obj) => (obj.Stage.id == match.stage_id)).Stage;
													}

													const closed = (moment.tz(stage_to_check.end_date,timezone).isBefore()) ? true : false;

													if(closed/* || is_test*/) {//Modo test necessary to close dates of stages
														const m = bracket.type == '1' ? {...match,scoreA:match.votesA,scoreB:match.votesB} : match;
														setMatchToVerify(m);
													} else {
														setDisplayStageClose(match);
													}
												}) : null;

												let candidateA_class = null;
												let candidateB_class = null;
												if(is_verified) {
													if(match.winner == match.candidateA.id) {
														candidateA_class = 'is_winner';
														candidateB_class = 'is_looser';
													} else {
														candidateA_class = 'is_looser';
														candidateB_class = 'is_winner';
													}
												}

												let candidateA_points = (is_verified) ? match.scoreA : match.votesA;
												candidateA_points = (!candidateA_points && bracket.type == '1') ? match.votesA : candidateA_points;

												let candidateB_points = (is_verified) ? match.scoreB : match.votesB;
												candidateB_points = (!candidateB_points && bracket.type == '1') ? match.votesB : candidateB_points;

												if(!all_in_one_stage) {
													actual_stage = stages.find((obj) => (obj.Stage.id == match.stage_id)).Stage;
												}

												const is_stage_closed = (moment.tz(actual_stage.end_date, timezone).isBefore()) ? true : false;

												return (
													<li key={`match_${m}`} class={(is_verified) ? 'is_verified' : null}>
														{(!all_in_one_stage) && (
															<div class="stage_info">
																<div class="match_title">
																	<p>
																		{i18n("Voting")} <ActionLink _href={`#stages/${actual_stage.id}/options`} autotranslate={false}>[{i18n("Edit")}]</ActionLink>
																	</p>
																</div>

																<p class="match_dates gui_is_not_padded">
																	{formatDateIntervals(actual_stage.start_date, actual_stage.end_date)}

																	{(is_stage_closed) && (
																		<strong class="redColor gui_not_in_start_tiny">
																			[{i18n("closed", 'ucfirst')}]
																		</strong>
																	)}
																</p>
															</div>
														)}

														<div class="teams">
															<div class={candidateA_class}>
																<span>
																	<span class="gui_cutTextOnOverflow">
																		<strong>{match.candidateA.name}</strong>
																	</span>
																</span>
																<span class="points">{(candidateA_points) ? candidateA_points : "-"}</span>
															</div>

															<div class={candidateB_class}>
																<span>
																	<span class="gui_cutTextOnOverflow">
																		<strong>{match.candidateB.name}</strong>
																	</span>
																</span>
																<span class="points">{(candidateB_points) ? candidateB_points : "-"}</span>
															</div>
														</div>

														{(!is_verified && !automatic_gen) && (
															<ButtonCollection _class={{other:'gui_flex_center'}}>
																<ActionButton
																	_class={{other:'smallButton'}}
																	onClick={verification_action}
																>Settle</ActionButton>
															</ButtonCollection>
														)}

														{(!automatic_gen && is_verified && !is_old_round) && (
															<ButtonCollection _class={{other:'gui_flex_center gui_not_in_top_tiny'}}>
																{(reseting_match == match.id) ? (
																	<div class="gui_pos_rel gui_not_in_end gui_not_padded_in_start">
																		<Spinner />
																	</div>
																) : (
																	<ActionLink
																		type="confirm"
																		_class={{other:'gui_small_text'}}
																		onClick={() => resetMatch(match)}
																	>Undo</ActionLink>
																)}
															</ButtonCollection>
														)}
													</li>
												)
											})}
										</ul>

										{(!can_generate_next_round && !is_old_round && !automatic_gen) && (
											<Message
												_class={{ other:'in_top not_in_bottom' }}
											>
												<p>{i18n("In order to generate the next round, you must first settle all the matchups in the round.")}</p>

												<p><strong>{i18n("Matchups pending to be settled")}: {matches_to_validate}</strong></p>
											</Message>
										)}

										{(!can_generate_next_round && !is_old_round && automatic_gen) && (
											<Message
												title="Automatic mode enabled"
												_class={{ other:'in_top not_in_bottom' }}
											>
												<p><FormattedMessage id="The round will automatically close at {end_round_date} h. The candidate with the most votes will automatically advance to the next round." values={{end_round_date:EPDateFormat(actual_stage.end_date, 'LL, HH:mm')}} /></p>
											</Message>
										)}
										
										{(bracket.current_round < 2 && matches_to_validate == matches_in_round.length && total_results == 0) && (
											<ButtonCollection>
												<ConfirmButton
													color="red"
													_position="right"
													onClick={resetRound}
												>Reset round</ConfirmButton>
											</ButtonCollection>
										)}
									</article>

									{(display_stage_close) && (
										<FloatingLayer
											_class={{ size:'small' }}
											backButton={() => setDisplayStageClose(false)}
										>
											<div>
												<SectionTitle _class={{icon:'knk-alert redIcon'}}>Votes open</SectionTitle>

												<SectionSubtitle>You will not be able to resolve the matchups until the voting period has ended.</SectionSubtitle>

												<ButtonCollection in_floating={true}>
													<ConfirmButton
														color="red"
														_position="top"
														onClick={(e, cb) => closeStage(display_stage_close.stage_id)}
													>Close votes now</ConfirmButton>

													<SecondaryButton
														onClick={() => setDisplayStageClose(false)}
													>Cancel</SecondaryButton>
												</ButtonCollection>
											</div>
										</FloatingLayer>
									)}

									{(match_to_verify !== false) && (
										<FloatingLayer
											_class={{ size:'small' }}
											backButton={() => setMatchToVerify(false)}
										>
											<div>
												<SectionTitle>Select the winner of the matchup</SectionTitle>

												<SectionSubtitle>Select the winner and enter the final score of the matchup.</SectionSubtitle>

												<ul class="winner_picker not_in_top">
													<li class={((match_to_verify.winner == match_to_verify.candidateA.id) ? 'selected' : null)}>
														<div class="title">{(match_to_verify.winner == match_to_verify.candidateA.id) ? i18n("Winner") : ((match_to_verify.winner == match_to_verify.candidateB.id) ? i18n("Out") : i18n("Candidate") + " A")}</div>

														<div class="is_team" onClick={() => selectWinner(match_to_verify.candidateA.id)}>
															{(match_to_verify.candidateA.full_image != undefined && match_to_verify.candidateA.full_image != "") && (
																<div class="candidate_img" style={{backgroundImage:`url(${match_to_verify.candidateA.full_image})`}}>
																	<img src={window.cdn_url + 'img/blank_1x1.png'} width="100%" />
																</div>
															)}

															<strong><span>{match_to_verify.candidateA.name.toUpperCase()}</span></strong>
														</div>

														<Model
															model={match_to_verify}
															change={changeConfirmMatch}
														>
															<Input
																name="scoreA"
																value={(bracket.type == '1' || match_to_verify.scoreA!=undefined) ? match_to_verify.scoreA : 0}
																_class={{first:true, size:50}}
															>Score</Input>
														</Model>

														{(bracket.type != '1') && (
															<div>
																<Message
																	icon={false}
																	_class={{ other:'in_bottom' }}
																>
																	<p>{i18n("Current votes")}: {match_to_verify.votesA}</p>
																</Message>
															</div>
														)}
													</li>

													<li class="vs">
														<span><span>{i18n("VS")}</span></span>
													</li>

													<li class={((match_to_verify.winner == match_to_verify.candidateB.id) ? 'selected' : null)}>
														<div class="title">{(match_to_verify.winner == match_to_verify.candidateB.id) ? i18n("Winner") : ((match_to_verify.winner == match_to_verify.candidateA.id) ? i18n("Out") : i18n("Candidate") + " B")}</div>

														<div class="is_team" onClick={() => selectWinner(match_to_verify.candidateB.id)}>
															{(match_to_verify.candidateB.full_image != undefined && match_to_verify.candidateB.full_image != "") && (
																<div class="candidate_img" style={{backgroundImage:`url(${match_to_verify.candidateB.full_image})`, transform:'scaleX(' + ((bracket.autoflip_candidates != undefined && bracket.autoflip_candidates == '1') ? -1 : 1) + ')'}}>
																	<img src={window.cdn_url + 'img/blank_1x1.png'} width="100%" />
																</div>
															)}

															<strong><span>{match_to_verify.candidateB.name.toUpperCase()}</span></strong>
														</div>

														<Model
															model={match_to_verify}
															change={changeConfirmMatch}
														>
															<Input
																name="scoreB"
																value={(bracket.type == '1' || match_to_verify.scoreB!=undefined) ? match_to_verify.scoreB : 0}
																_class={{first:true, size:50}}
															>Score</Input>
														</Model>

														{(bracket.type != '1') && (
															<div>
																<Message
																	icon={false}
																	_class={{ other:'in_bottom' }}
																>
																	<p>{i18n("Current votes")}: {match_to_verify.votesB}</p>
																</Message>
															</div>
														)}
													</li>
												</ul>

												{(tied_match && !(match_to_verify.winner != undefined && match_to_verify.winner != "")) && (
													<ButtonCollection _class={{other:'gui_flex_center gui_flex_col not_in_top'}}>
														<span>{i18n("The candidates got the same results")}. {i18n("You can")}:</span>

														<ConfirmButton
															_position="top"
															onClick={confirmRandom}
														>Pick the winner randomly</ConfirmButton>
													</ButtonCollection>
												)}

												<ButtonCollection in_floating={true}>
													<ConfirmButton
														disabled={(isNotEmpty(match_to_verify, 'winner')) ? false : true}
														tooltip={(!isNotEmpty(match_to_verify, 'winner')) ? <Tooltip position="top" with_icon={false}>To select the winner, you need to click on the candidate above</Tooltip> : null}
														_position="left"
														onClick={(isNotEmpty(match_to_verify, 'winner')) ? confirmMatch : null}
													>Confirm result</ConfirmButton>

													{!(match_to_verify.winner != undefined && match_to_verify.winner != "") && (
														<p class="extra_message"><span>{i18n("To select the winner, please click on the candidate", 'uppercase')}</span></p>
													)}
												</ButtonCollection>
											</div>
										</FloatingLayer>
									)}
								</BuilderSidebar>

								<BuilderCanvas is_adaptable={false}>
									{(has_all_candidates) ? (
										<div id="bracket_dom" class="gui_bracket_builder brackets_display bracket_dom">
											<BracketsNotCanvas
												ref={(node) => { bracket_ref.current = node; }}
												matches_results={matches_results}
												is_builder={true}
												current_round={parseInt(round_id)}
												teams={candidates_for_bracket}
												{...bracket_defaults}
												{...default_canvas_values}
											/>
										</div>
									) : (
										<p><FormattedMessage id="To see the bracket, first you need to create the {num_candidates} candidates" values={{num_candidates:total_candidates_needed}} /></p>
									)}
								</BuilderCanvas>
							</>
						)
					}} />
				</Switch>
			</Router>

			{(display_automatic_options && !is_promo_ended) && (
				<FloatingLayer _class={{size:'normal'}} enable_close={false}>
					<div>
						<SectionTitle _class={{icon:'knk-settings', other:'blackColor'}}>Rounds scheduler</SectionTitle>
						<p>{i18n("Timezone")}: <strong>{pm.timezone}</strong></p>

						{(error_round_dates != 0) && (
							<p class="redColor knk-alert">{i18n("Error configuring automatic dates")}</p>
						)}

						<ul class="automatic_rounds_config">
							{rounds_in_bracket.map((round, r) => {
								const index_round = r + 1;

								const is_past_round = (bracket.current_round > index_round) ? true : false;

								const title_round = (bracket['round_'+index_round]) ? bracket['round_'+index_round] : i18n("Round") + ' ' + index_round;
								const defined_round = (bracket['start_round_' + index_round] != null && bracket['end_round_' + index_round] != null) ? true : false;

								let min_date = (index_round > 1) ? bracket['end_round_'+(index_round-1)] : pm.start_date;
								let max_date = (index_round > 1 && index_round < bracket.num_rounds && bracket['start_round_' + (index_round + 1)]) ? bracket['start_round_' + (index_round + 1)] : pm.end_date;
								const roundedDown = Math.floor(EPGetDateMinutes(max_date) / 5) * 5;
								const roundedUp = Math.ceil(EPGetDateMinutes(min_date) / 5) * 5;
								min_date = EPGetDateSeconds(EPGetDateMinutes(min_date, roundedUp), 0);
								max_date = EPGetDateSeconds(EPGetDateMinutes(max_date, roundedDown), 0);

								let start_date = bracket['start_round_'+index_round] ? EPDate(bracket['start_round_'+index_round]) : EPGetDateSeconds(EPGetDateMinutes(pm.start_date, roundedUp), 0);
								let end_date = bracket['end_round_'+index_round] ? EPDate(bracket['end_round_'+index_round]) : EPGetDateSeconds(EPGetDateMinutes(pm.end_date, roundedUp), 0);
								if(EPDateBefore(start_date, min_date)) start_date = min_date;
								if(EPDateBefore(max_date, end_date)) end_date = max_date;

								const previous_round_defined = (bracket['start_round_'+(index_round - 1)] != null && bracket['end_round_'+(index_round - 1)] != null || index_round == 1) ? true : false;
								let enable_set_dates_round = false;
								if(index_round <= (bracket.current_round + 1) && previous_round_defined || index_round > bracket.current_round && previous_round_defined && round_dates_editing == 0 || index_round == bracket.current_round && !previous_round_defined) enable_set_dates_round = true;
								let is_editing = (round_dates_editing == index_round || error_round_dates == index_round) ? true : false;

								return (
									<li key={`round_date_${r}`} class={(is_past_round) ? 'disabled' : null}>
										<div class={(is_editing) ? 'selected' : null}>
											<strong>{title_round}</strong>

											{(!is_editing) && (
												<div>
													{(defined_round) && (
														<div class="dates_info">
															<span>{formatDateIntervals(bracket['start_round_' + index_round], bracket['end_round_' + index_round], 'L, LT')}</span>

															{(!is_past_round && round_dates_editing == 0) && (
																<ActionLink
																	onClick={() => setRoundDates(index_round)}
																>Edit schedule</ActionLink>
															)}
														</div>
													)}

													{(!defined_round && enable_set_dates_round && !is_past_round && round_dates_editing == 0) && (
														<div class="dates_info">
															<span>{i18n("Dates not scheduled")}.</span>
															{(round_dates_editing == 0) && (
																<ActionLink
																	onClick={() => setRoundDates(index_round)}
																>Schedule</ActionLink>
															)}
														</div>
													)}

													{(!defined_round && (!enable_set_dates_round || round_dates_editing > 0) && !is_past_round) && (
														<div class="dates_info">
															<span>{i18n("Dates not scheduled")}. <strong>{i18n("Schedule previous round first")}.</strong></span>
														</div>
													)}

													{(is_past_round) && (
														<div class="dates_info">
															<span>{i18n("Past round")}</span>
														</div>
													)}
												</div>
											)}
										</div>

										{(is_editing) && (
											<div class={'round_settings' + ((error_round_dates == index_round) ? ' redColor' : '')}>
												<Model
													classname="gui_equal_columns gui_padded_children_low"
													model={bracket}
													change={modifyBracket}
												>
													<DateTimePicker
														_class={{first:true}}
														name={`start_round_${index_round}`}
														show_time={true}
														min_date={min_date}
														max_date={max_date}
														value={start_date}
														position="top-start"
													>Start date</DateTimePicker>

													<DateTimePicker
														_class={{first:true}}
														name={`end_round_${index_round}`}
														show_time={true}
														min_date={min_date}
														max_date={max_date}
														value={end_date}
														position="top-start"
													>End date</DateTimePicker>
												</Model>

												<Model
													model={bracket}
													change={modifyBracket}
												>
													<Input
														_class={{size:30}}
														name={`score_round_${index_round}`}
														_type="number"
														min={1}
														max={10000}
													>Points for correct answer</Input>
												</Model>

												<ButtonCollection _class={{other:'gui_flex_end not_in_top'}}>
													<ActionLink
														_class={{other:'gui_not_padded_in_end_small'}}
														onClick={closeRoundDates}
													>Cancel</ActionLink>

													<ActionButton
														onClick={validateRoundDates}
													>Save round</ActionButton>
												</ButtonCollection>
											</div>
										)}
									</li>
								)
							})}
						</ul>

						{!(round_dates_editing > 0 || error_round_dates) ? (
							<ButtonCollection in_floating={true}>
								<SaveButton
									onClick={(e, cb) => saveBracket(cb)}
								>Save</SaveButton>

								<SecondaryButton
									icon='knk-off'
									onClick={() => {
										setDisplayAutomaticOptions(false);
										setRoundDatesEditing(0);
									}}
								>Close</SecondaryButton>
							</ButtonCollection>
						) : (
							<ButtonCollection in_floating={true}>
								<SaveButton
									disabled={true}
								>Save</SaveButton>

								<SecondaryButton
									disabled={true}
									icon='knk-off'
								>Close</SecondaryButton>
							</ButtonCollection>
						)}
					</div>
				</FloatingLayer>
			)}

			{(display_automatic_options && is_promo_ended) && (
				<ExpiredPromoLayer
					timezone={pm.timezone}
					end_date={pm.end_date}
					intl={props.intl}
				/>
			)}

			{((display_next_round_layer || generating) && automatic_gen) && (
				<FloatingLayer
					_class={{ size:'small' }}
					backButton={() => closeGeneratingRoundLayer()}
				>
					<div>
						<SectionTitle>Automatic bracket</SectionTitle>

						<SectionSubtitle>When you continue, we'll automatically generate the first round of matchups of the competition with the start and end dates that you have scheduled, so your users can start voting.</SectionSubtitle>

						<ButtonCollection in_floating={true}>
							<ConfirmButton
								color="green"
								_position="top"
								onClick={nextPhase}
							>Continue</ConfirmButton>

							<SecondaryButton
								onClick={() => closeGeneratingRoundLayer()}
							>Cancel</SecondaryButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}

			{(display_no_subscription_layer) && (
				<FloatingLayer
					_class={{ size:'small' }}
					backButton={() => setDisplayNoSubscriptionLayer(false)}
				>
					<div>
						<SectionTitle _class={{ icon:'knk-subscription' }}>White Label plan</SectionTitle>

						<SectionSubtitle autotranslate={false}>{i18n("You need an active White Label plan to test all bracket tournament while the promotion is in draft mode.")} <ActionLink _href={window.panel_url+'plans'} _target="_blank" autotranslate={false}>{i18n("Buy a White Label plan")}</ActionLink></SectionSubtitle>

						<ButtonCollection in_floating={true}>
							<SecondaryButton
								onClick={() => setDisplayNoSubscriptionLayer(false)}
							>Close</SecondaryButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}

			{((display_next_round_layer || generating) && !automatic_gen && enable_generate_round) && (
				<FloatingLayer
					_class={{ size:'small' }}
					backButton={() => closeGeneratingRoundLayer()}
				>
					<div>
						<div class="gui_pos_rel">
							<SectionTitle autotranslate={false}>
								<FormattedMessage
									id="Generate round #{round}"
									values={{
										round:(parseInt(bracket.current_round) + 1),
									}}
								/>
							</SectionTitle>

							<SectionSubtitle>Generate the voting page for each of the matchups in the round.</SectionSubtitle>

							<SectionSubtitle>After generating the voting, you can customize the voting dates and other options of the voting page.</SectionSubtitle>

							<article>
								<Model model={temp_options} change={changeTempOptions}>
									<Input
										name="points_per_question"
										min={1}
										max={10000}
										_type="number"
										_class={{ size:20 }}
									>How many points per correct prediction?</Input>
								</Model>

								{(!will_be_final_round) && (
									<div>
										<Model model={temp_options} change={changeTempOptions}>
											<Select
												name="pairings_round"
												values={asking_groupings}
											>Select how to generate the voting system</Select>
										</Model>

										{(parseInt(temp_options.pairings_round) > 1) && (
											<Message
												icon={false}
												_class={{ other:'in_bottom' }}
											>
												<p>{i18n("This will generate a single voting page for all the matchups of the round.")}</p>

												<p><strong>{i18n("Recommended when the voting dates are the same for all the matchups of the round.")}</strong></p>
											</Message>
										)}
										
										{(parseInt(temp_options.pairings_round) == 1) && (
											<Message
												icon={false}
												_class={{ other:'in_bottom' }}
											>
												<p>{i18n("This will generate an independent voting page for each matchup of the round. You can define the voting dates for each matchup.")}</p>

												<p><strong>{i18n("Recommended when the voting of the matchups in the same round take place on different days.")}</strong></p>
											</Message>
										)}
									</div>
								)}

								{(will_be_final_round) && (
									<Message
										title={i18n("This will be the final round of the bracket")}
										_class={{ other:'in_bottom' }}
									/>
								)}
							</article>
						</div>

						<ButtonCollection in_floating={true}>
							<ConfirmButton
								_position="top"
								onClick={nextPhase}
							>{(!will_be_final_round) ? "Generate round" : "Generate final round"}</ConfirmButton>
						</ButtonCollection>

						{(generating) && (
							<Spinner force_bg={true}>Generating round. Please wait until it's complete.</Spinner>
						)}
					</div>
				</FloatingLayer>
			)}

			{((display_next_round_layer || generating) && !automatic_gen && !enable_generate_round) && (
				<FloatingLayer
					_class={{ size:'small' }}
					backButton={() => closeGeneratingRoundLayer()}
				>
					<div>
						<SectionTitle _class={{icon:'knk-alert redIcon'}}>Attention!</SectionTitle>

						<SectionSubtitle>To generate the round, the promotion has to be active.</SectionSubtitle>

						<SectionSubtitle>If you want to test how a round is generated and how the matchup voting system works, you can try it with the promotion in Test Mode.</SectionSubtitle>

						<ButtonCollection in_floating={true}>
							<TestPromoButton
								promotion={promotion}
								onChangeTest={(test) => activateTest()}
								intl={props.intl}
								current_active={0}
								is_builder={true}
								action_button={true}
							/>
							{/*
							<ActionButton
								onClick={() => activateTest()}
							>Enable test mode</ActionButton>
							*/}
							

							<SecondaryButton
								onClick={() => closeGeneratingRoundLayer()}
							>Close</SecondaryButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}
		</BuilderMain>
	);
};

function select(state) {
	return state;
}

export default connect(select)(injectIntl(BracketsEdit));